import { render, staticRenderFns } from "./file-uploader.vue?vue&type=template&id=2405f3d8"
import script from "./file-uploader.vue?vue&type=script&lang=ts"
export * from "./file-uploader.vue?vue&type=script&lang=ts"
import style0 from "./file-uploader.vue?vue&type=style&index=0&id=2405f3d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports